export const TYPE = 'type';
export const TEXT = 'text';
export const EXPIRATION_DATE = 'expirationDate';
export const NOTIFY_BY_EMAIL = 'notifyByEmail';

export const TAB_EDITOR = 'editor';
export const TAB_PREVIEW = 'preview';
